/**
 * @author: SuperHorse.马超 machao@meitunmama.com
 * Created on 2018/11/8.
 *
 */
export default {
  bindExpert: '/newapi/router/health-expert-bind/bindV2', // 专家绑定宝宝树账号接口
  checkExpert: '/newapi/router/health-expert-check/checkV2', // 专家绑定宝宝树账号接口
  proList: '/mobile/home/getprovlist.htm',     // 获取省份地址列表
  areaList: '/mobile/home/getarealist.htm',    // 获取城市区县地址列表
  authentication: '/newapi/router/user/authentication', // 绑定实名认证
  mtUploadPic: '/mobile/system/uploadpictures.htm?imagewidth=120&imageheight=120',  // 美囤上传图片
  getCountryInfo: '/newapi/router/base-district/getCountryInfo'  // 获取国籍
};



// WEBPACK FOOTER //
// ./src/comm/api/dayima/index.js